import { BareButton } from '@calendly/ui/components/bare-button'
import { LabelText } from '@calendly/ui/components/typography'

import styles from './ChatSuggestions.module.css'
import { IconAiSparkleMiniGradient } from '../assets/icon-ai-sparkle-mini-gradient'

/**
 * ChatSuggestions component displays a list of clickable suggestion chips for chat interactions.
 *
 * This component renders a horizontal row of suggestion buttons that users can click
 * to quickly select predefined responses or actions in a chat interface.
 *
 * @param {Object} props - Component props
 * @param {Array<Object>} props.chatSuggestions - Array of suggestion objects to display
 * @param {string} props.chatSuggestions[].id - Unique identifier for the suggestion
 * @param {string} props.chatSuggestions[].text - Display text for the suggestion
 * @param {Function} props.onSuggestionClick - Callback function called when a suggestion is clicked
 * @param {Object} props.onSuggestionClick.suggestion - The clicked suggestion object
 *
 * @returns {JSX.Element} A container with clickable suggestion chips
 *
 * @example
 * ```jsx
 * const suggestions = [
 *   { id: '1', text: 'Hello' },
 *   { id: '2', text: 'How can I help?' }
 * ];
 *
 * <ChatSuggestions
 *   chatSuggestions={suggestions}
 *   onSuggestionClick={(suggestion) => console.log(suggestion.text)}
 * />
 * ```
 */
export const ChatSuggestions = ({ chatSuggestions, onSuggestionClick }) => (
  <div className={styles.suggestionsRow}>
    {chatSuggestions.map((suggestion) => (
      <BareButton
        key={suggestion.id}
        className={styles.suggestionChip}
        decoration="ghost"
        onClick={() => onSuggestionClick(suggestion.text)}
      >
        <div className={styles.aiSparkleIconContainer}>
          <IconAiSparkleMiniGradient />
        </div>
        <LabelText>
          {suggestion.text}
        </LabelText>
      </BareButton>
    ))}
  </div>
)
